import { useNetworkPerformanceActions, useNetworkPerformanceStore } from 'stores/networkPerformanceStore';

import createInsightsDashboardContainer from '../shared/createInsightsDashboardContainer';

import NetworkPerformancePage from './NetworkPerformancePage';

const { Context, useDashboardContext, Container } = createInsightsDashboardContainer({
  preferenceKey: 'networkPerformanceProviderType',
  useSelectedGroupType: () => useNetworkPerformanceStore((state) => state.selectedGroupType),
  useActions: () => {
    const { setSelectedGroupType, setPredecessorGroupTypeId, resetFilters } = useNetworkPerformanceActions();
    return { setSelectedGroupType, setPredecessorGroupTypeId, resetFilters };
  },
  Page: NetworkPerformancePage,
});

export const NetworkPerformanceContext = Context;
export const useNetworkPerformanceContext = useDashboardContext;
export default Container;
